import { CompleteVerifiedRecord } from "../jotai/atoms";

const REVIEW_DEQUEUED_AT_THRESHOLD = 1_000 * 60 * 60 * 24 * 1; // 1 day
/**
 * Only ask the user to rate the app if they have accepted consent and they have a verified record that was dequeued
 * in the last X amount of time. This ensures we only ask people who recently got a record to rate the app. It also
 * means that when flipping from the react-native to the capacitor app, we don't immediately present them with a
 * dialog asking them to rate the app after they click through the consent acceptance.
 */
export function shouldRateTheApp(
  appRated: boolean,
  consentAccepted: boolean,
  records: CompleteVerifiedRecord[]
): boolean {
  if (appRated || !consentAccepted) {
    return false;
  }
  const latestRecord = records.reduce((latest, record) => {
    const dequeuedAt = record.record.dequeuedAt ? new Date(record.record.dequeuedAt) : null;
    if (dequeuedAt && (!latest || dequeuedAt > latest)) {
      return dequeuedAt;
    }
    return latest;
  }, null as Date | null);

  return (
    latestRecord !== null && latestRecord.getTime() + REVIEW_DEQUEUED_AT_THRESHOLD > Date.now()
  );
}
